import rightImg from "images/rightimg.png";
import SectionGridFeaturePlaces from "./SectionGridFeaturePlaces";
import SectionHero from "containers/PageAbout/SectionHero";
import SectionClientSay from "components/SectionClientSay/SectionClientSay";
import { globalJson } from "global/global_json";
import { useEffect } from "react";

import SiteHeader from "containers/SiteHeader";
import MobileSearch from "components/MobileSearchForm/MobileSearch";
import BrowseByBrands from "components/BrowseBrand/BrowseBrand";
import BrowseLocation from "components/BrowseLocation/BrowseLocation";
import CarRentalSteps from "components/Steps/Steps";
import FAQ from "components/FAQ/FAQ";
import SectionHero4 from "components/SectionHero/SectionHero";
import { clearRenterSession } from "utils/renterSession";


function PageHome3() {
  useEffect(() => {
    clearRenterSession();
  }, []);
  return (
    <>
      <div className="nc-PageHome3 relative overflow-hidden">
        <div
          className={
            "md:bg-[url('images/travelhero2.png')] bg-[url('images/travelhero.png')] justify-between flex flex-col bg-cover md:bg-center w-full h-screen"
          }
        >
          <div className="container relative px-0 z-40">
            <div className="md:pt-4">
              <div className="rounded-3xl overflow-clip">
                <SiteHeader />
              </div>
            </div>
            <div className="lg:hidden mt-36 px-4 md:px-0 mb-16 md:mb-0">
              <MobileSearch />
            </div>
            <div className="container relative lg:pb-16 lg:pt-8 md:pt-0 sm:pt-0 px-0 md:pb-0 sm:pb-0 mt-0">
              <SectionHero4 />
            </div>
          </div>
        </div>
        {/* </div> */}
        <div className="container bg-[#F5F5F7] mt-12 rounded-2xl relative py-16">
          <SectionGridFeaturePlaces />
        </div>
        <div className="container relative" style={{ padding: "0px" }}>

          <div className="container py-16  space-y-16 lg:space-y-28">
            <BrowseByBrands />
          </div>
          <div className="container py-16  space-y-16 lg:space-y-28">

            <SectionHero
              rightImg={rightImg}
              heading="Welcome to Kings Car Rentals"
              btnText=""
              subHeading={globalJson?.about_us_para}
            />
          </div>

        </div>
        <div className="bg-black">
          <div className="container py-16  space-y-16 lg:space-y-28"> <BrowseLocation /></div>
        </div>
        <div className="container py-16   space-y-16 lg:space-y-28"> <CarRentalSteps /></div>
        <div className="bg-[#595A5B]">

          <div className="relative py-16">
            {/* <BackgroundSection /> */}
            <SectionClientSay uniqueClassName="PageAbout_" />
          </div>

        </div>
      </div>
      <div className="container py-16   space-y-16 lg:space-y-28"> <FAQ /></div>
    </>
  );
}

export default PageHome3;
